export const richTextEditorSelectors = {
  toolbar: 'rich-text-editor-toolbar'
};
